import React from 'react';
import { View, Text, StyleSheet, Pressable, Image } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

interface UserCardProps {
    user: any;
    sessionDays: string[];
    attendance: any;
    onSummaryPress?: (userId: string) => void;
    showSummaryButton?: boolean;
}

const UserCard: React.FC<UserCardProps> = ({ 
    user, 
    sessionDays, 
    attendance,
    onSummaryPress,
    showSummaryButton = false
}) => {
    const attendedDays = sessionDays.reduce(
        (count, date) => count + (attendance[date]?.[user.userId] === true ? 1 : 0), 
        0
    );

    return (
        <View style={[styles.userCard, showSummaryButton && { alignItems: 'center' }]}>
            {user.profileImage ? (
                <Image
                    source={{ uri: user.profileImage }}
                    style={styles.userAvatarImage}
                />
            ) : (
                <View style={styles.userAvatar}>
                    <MaterialCommunityIcons name="account-child" size={20} color="#666" />
                </View>
            )}
            <View style={styles.userInfo}>
                <View style={{ flex: 1 }}>
                    <Text style={styles.userName}>
                        {user.childName || user.userName || 'Unknown Camper'}
                    </Text>
                    <Text style={styles.userEmail}>
                        {showSummaryButton 
                            ? `${attendedDays} / ${sessionDays.length} days attended`
                            : `${user.age ? `Age: ${user.age}` : ''} ${user.parentName ? `• Parent: ${user.parentName}` : ''}`
                        }
                    </Text>
                </View>
                {showSummaryButton && onSummaryPress ? (
                    <Pressable 
                        style={styles.summaryButton} 
                        onPress={() => onSummaryPress(user.userId)}
                        accessibilityLabel="Open summary"
                    >
                        <MaterialCommunityIcons name="view-grid" size={18} color="#2C67D6" />
                    </Pressable>
                ) : (
                    <View style={styles.userStats}>
                        <Text style={styles.userStatsText}>
                            {attendedDays} / {sessionDays.length}
                        </Text>
                        <Text style={styles.userStatsLabel}>Attended</Text>
                    </View>
                )}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    userCard: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 16,
        borderWidth: 1,
        borderColor: '#e9ecef',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 2,
        elevation: 1,
    },
    userAvatar: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#f0f0f0',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 12,
    },
    userAvatarImage: {
        width: 40,
        height: 40,
        borderRadius: 20,
        marginRight: 12,
        borderWidth: 1,
        borderColor: '#E0E0E0',
    },
    userInfo: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    userName: {
        fontSize: 16,
        fontWeight: '600',
        color: '#1a1a1a',
        marginBottom: 2,
    },
    userEmail: {
        fontSize: 14,
        color: '#666',
    },
    userStats: {
        alignItems: 'flex-end',
    },
    userStatsText: {
        fontSize: 18,
        fontWeight: '700',
        color: '#2C67D6',
    },
    userStatsLabel: {
        fontSize: 12,
        color: '#666',
        marginTop: 2,
    },
    summaryButton: {
        width: 36,
        height: 36,
        borderRadius: 18,
        backgroundColor: '#f8f9fa',
        borderWidth: 1,
        borderColor: '#e9ecef',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default UserCard;

